import './Footer.css';

export const Footer = () => <footer className='footer'></footer>;

export default Footer;
